var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_237_2258)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_237_2258",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_237_2258",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_237_2258",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADvklEQVR4nO2dW0hUQRjHN9Ogpwh66iEoil4kCIpeyksRmBQEkeiLQpgQvoiCRIUEEWwRgSAJFkVGFEFkGF0gME2zi0V2IZSuiIY5Z2ePe2nX3fWLWXUX21WPZ2edw57/D76X2T0zh+83882c3YV1OAAAAAAAAAAAAAAAAAAAAAAAIIb/YnWFz1lVIzPGOC/IhPBJzovI9YJTL1SyPkC7HCQzGNczIkhyXkSuIYRDiPKZzbBCULIIJUvHCsGm7sCmzrCH4NjLcOzVlZ+o8BxigYQzCFGfZAYh6hPLICS9ieLvX5D7TSeEWOI5hGkUOrKVwmWbSRsdxQpRLcTXfCI2jr+pHkJUCuHveoh2r4iPVZBN7tfPsIekWwj/2Ee8v3d2+xijUMWWxO8YynOJ/RmbfX1/b7QPbOqShOid7UR5yyhYW0Tuvq5om//S8TkngHgtKuLDKwo0lBLlLye96wGEyBLifvs8nvD8LArWFRMV5sy9Kgtzpt6TnxVrE31ghUgS4hr4lPLXpa7BzxAiS4g2MpyyENEHVojEUxbNV6IWioJsYi43hMgUEtm/xrQQca2USSHhq4iM+dVJuHSj6fHDZZsgJBUh2u+RhLZQ5XbzM7FyW9J9CSvEoBBvq5NCR3fQ+JPbsdo/UbPXtBBx7Uzf7p7HNFGdR94b5yHEqBDf1TPx2V2eS+Pt1ylw8rBpIYFTJTERM23ea2chxLCQK6eTnpTMCpncszKhTYyBkpVkr9CGfiWEv7FW+onm/xBjJBs72f5lm1OW515L2hNPiwxP22X7ChERrD+gXAJNh/jw0vbPIa7vAzRZvFq5jMmiVeT6+gVCrFK6PPOUKluVLCuUrmDdPkP3aCshrh+DSkqXkVJlPyFMI8/dZoocXLvkQsSYYmxxDxCi8ehTeCofHJIsMYfWkfdW47xiMn6F6B33KVyyQbkMmg5xL+KebCvEKqskYmB12EeIQjERgyLsKWQJxUQWKcLeQnj85PXXWSU9CaLPxYqAED6VBO/NC9KFiD5NTRDbrxAOIdYqWRxCLCdE735I/sYa8rU0kLf1HHnuNEU3fL2jjdwvn5Le/ShhLNEWfa2jLfpecY24VvQh+hJ9omSZFMIWCNfPbwlCRFu6xrP3KYtDCIRwrJCUVog2PEQTx3bOCtGGkqWoZLElDuwhXL0ECOHqEw8hFkg2gxD1CWYQoj6pDEJwyiK7PKkzrBAIIXyWpVsm8GDI1UuAEK4+8ZYSgr+r4Nb6uwoAAAAAAAAAAAAAAAAAAAAAgMM+/AO1sDz3nB1g2gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/Canada.9179ccc4e8f6447cfe6e12dab481b37b.svg";
export { ForwardRef as ReactComponent };